import Vue from 'vue';
import errorHandler from './errorHandler';
import NavItem from '../components/routes/admin/_NavItem';

export default {
    mixins: [errorHandler],

    data: () => ({
        model: null,
        rows: null,
        route: null,
        filters: {},
        defaults: {},
    }),

    computed: {
        filteredRows() {
            let config = this.filters[this.$route.query.filter];

            if (!config) {
                config = this.filters.default;
            }

            return this.rows.filter(config.filter);
        },

        title: vm => (vm.filters[vm.$route.query.filter]
            ? vm.filters[vm.$route.query.filter].title
            : vm.filters.default.title),

        icon: vm => (vm.filters[vm.$route.query.filter]
            ? vm.filters[vm.$route.query.filter].icon
            : vm.filters.default.icon),

        count: vm => param => vm.rows.filter((vm.filters[param] || vm.filters.default).filter).length,
    },

    methods: {
        async load() {
            this.$Progress.start();
            this.rows = null;

            try {
                this.rows = await this.Model.getAdminList();
                this.$Progress.finish();
            } catch (err) {
                this.catchError('Ladefehler', 'Die benötigten Daten konnte nicht geladen werden', err);
                this.$Progress.fail();
            }
        },

        async update(id, data) {
            const row = this.rows.find(r => r.id === id);
            const prev = {};

            if (!row) {
                throw new Error('Record not found');
            }

            try {
                Object.keys(data).forEach((k) => {
                    prev[k] = row[k];
                    row[k] = data[k];
                });
                row.save();
            } catch (err) {
                Object.keys(prev).forEach((k) => {
                    row[k] = prev[k];
                });

                throw err;
            }
        },

        navItem(filter, color = '') {
            const to = { name: this.route };

            if (filter !== 'default') {
                to.query = { filter };
            }

            return Vue.extend({
                mixins: [NavItem],
                data: () => ({
                    to,
                    icon: this.filters[filter].icon,
                    title: this.filters[filter].navTitle || this.filters[filter].title,
                    count: this.count(filter),
                    countColor: color,
                }),
            });
        },
    },

    created() {
        this.load();
    },
};
